export default __webpack_public_path__ + "static/media/definition-strategie-velo.4597348d.jpg";